// External Modules
import { lazy } from 'react';
import { Outlet, Routes, Route } from 'react-router-dom';

// Internal Modules
import { GlobalProviders, PageLayout } from '@apolitical/component-library';
import loadSdk, { decodeBase64, people, reportError } from '@apolitical/sdk';

// Styles
import '@apolitical/component-library/style.css';

// Constants
import { LINKS, SERVICE_NAME, USER_ME } from './constants';

// Pages
const EventsOverview = lazy(() => import('./pages/EventsOverview'));
const Event = lazy(() => import('./pages/Event'));
const Registration = lazy(() => import('./pages/EventRegistration/Registration'));

// Messages
const messages = require('../locales/en.json');

function App() {
  async function bootstrap() {
    // Load the SDK
    loadSdk({
      contentContext: {
        apiKey: decodeBase64(process.env.REACT_APP_CDA_API_KEY),
        previewKey: decodeBase64(process.env.REACT_APP_CPA_API_KEY),
      },
      errorsContext: {
        apiKey: decodeBase64(process.env.REACT_APP_GCP_ERRORS_API_KEY),
        serviceName: SERVICE_NAME,
      },
      googleMapsContext: {
        apiKey: decodeBase64(process.env.REACT_APP_GOOGLE_MAPS_API_KEY),
      },
      gtmContext: {
        configs: JSON.parse(decodeBase64(process.env.REACT_APP_GTM_ID)),
      },
      origin: window.origin || window.location.origin,
    });
    // Fetch logged-in user (/me)
    const me = await people.users.read(USER_ME);
    // It must return the user object
    return me;
  }

  return (
    <GlobalProviders bootstrap={bootstrap} intl={{ messages }}>
      <Routes>
        <Route
          element={
            <PageLayout reportError={reportError} suprSendWorkspaceKey={process.env.REACT_APP_SUPRSEND_WORKSPACE_KEY}>
              <Outlet />
            </PageLayout>
          }
        >
          <Route exact path={LINKS.HOME} element={<EventsOverview />} />
          <Route exact path={LINKS.EVENT} element={<Event />} />
        </Route>
      </Routes>
      <Routes>
        <Route
          element={
            <PageLayout
              reportError={reportError}
              suprSendWorkspaceKey={process.env.REACT_APP_SUPRSEND_WORKSPACE_KEY}
              forceShow={{
                navigation: false,
                footer: false,
              }}
            >
              <Outlet />
            </PageLayout>
          }
        >
          <Route path="/:slug/save" element={<Registration step="save" />} />
          <Route path="/:slug/share" element={<Registration step="share" />} />
          <Route path="/:slug/join" element={<Registration step="join" />} />
        </Route>
      </Routes>
    </GlobalProviders>
  );
}

export default App;
